"use client";

import { c as _c } from "react/compiler-runtime";
import { Highlight, useBreakpointValue } from "@chakra-ui/react";
import { Fragment } from "react";
type ResponsiveTextWithHighlightProps = {
  text: string;
  highlight: string;
  highlightStyle?: object;
};
const ResponsiveTextWithHighlight = t0 => {
  const $ = _c(3);
  const {
    text,
    highlight,
    highlightStyle
  } = t0;
  const lines = text.split("\n");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      base: true,
      xl: false
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const insertBreak = useBreakpointValue(t1);
  const t2 = lines.map((line, index) => <Fragment key={index}><Highlight query={highlight} styles={highlightStyle}>{line}</Highlight>{insertBreak && index < lines.length - 1 ? <br /> : " "}</Fragment>);
  let t3;
  if ($[1] !== t2) {
    t3 = <>{t2}</>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
};
export default ResponsiveTextWithHighlight;